import React from "react";

const MorePain = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_939_532)">
                <ellipse cx="24.0002" cy="24" rx="22.9787" ry="23" fill="white" />
                <path
                    d="M0.00718224 24.0514C-0.300761 11.4437 10.0501 -0.0283565 24.0303 -8.60867e-06C38.0106 0.0283392 47.9574 11.5163 48.0001 23.9433C48.0464 37.3129 36.9319 47.9362 24.1478 47.9982C10.8137 48.062 -0.19752 37.1623 0.00718224 24.0514ZM2.02038 23.9805C1.83526 35.8033 11.4865 45.8863 23.847 45.9696C36.4371 46.0529 45.9958 35.7431 45.9815 24C45.9673 12.4908 36.9835 2.09773 24.0997 2.01446C11.2694 1.93119 1.8228 12.2906 2.01326 23.9805H2.02038Z"
                    fill="black"
                />
                <path
                    d="M18.7097 22.0334C18.7097 24.326 16.9866 26.1349 14.8363 26.0995C12.5401 26.0605 10.9114 24.3898 10.7779 22.145C10.6675 20.2758 12.2482 18.2223 14.6939 18.0416C16.7249 17.8928 18.7079 19.9622 18.7097 22.0334Z"
                    fill="black"
                />
                <path
                    d="M37.1811 22.0989C37.149 24.1967 35.2569 26.0712 33.1404 26.0977C30.9742 26.1261 29.2707 24.3419 29.2725 22.044C29.2742 19.7461 30.9386 18.054 33.2063 18.0204C35.2373 17.992 37.2131 20.0189 37.1811 22.0989Z"
                    fill="black"
                />
                <path
                    d="M29.4415 33.4044C30.262 34.882 30.262 34.882 29.4415 36.372C26.2107 36.372 22.9034 36.3986 19.5944 36.3579C18.5086 36.3437 18.1081 35.8653 18.1045 34.8909C18.101 33.9164 18.5104 33.4345 19.5926 33.4203C22.907 33.3778 26.2214 33.4044 29.4415 33.4044Z"
                    fill="black"
                />
                <path
                    d="M18.7455 9.55497C18.3112 9.96602 18.0086 10.4001 17.5939 10.5985C17.2681 10.7562 16.8018 10.6428 16.3995 10.6162C13.8843 10.4497 11.6433 11.1956 9.55708 12.5652C8.48907 13.2632 8.46059 13.2207 7.5332 12.1523C10.5575 9.17228 15.1855 8.02596 18.7455 9.55497Z"
                    fill="black"
                />
                <path
                    d="M40.5451 12.5634L39.5821 13.3767C38.9555 13.0081 38.3539 12.6449 37.7415 12.2994C35.65 11.1195 33.4196 10.5277 31.0006 10.6694C30.1711 10.7226 29.2864 10.7722 29.4894 9.48769C33.3413 8.28113 38.1776 9.59753 40.5451 12.5634Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_939_532">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default MorePain;
